export default __webpack_public_path__ + "static/media/company-green.f36fb109.svg";